module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_3009.94d93d02.png";